var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"pay-result"},[_c('img',{attrs:{"src":require("./successOrFail_img/fail.png"),"alt":""}}),_c('p',[_vm._v("支付失败")]),_c('a',{staticClass:"btn",attrs:{"href":"http://happytalk.tw/mycard/newPay/pay/#/"}},[_vm._v("返回")])])])
}]

export { render, staticRenderFns }